import React, { useState, useEffect, useContext } from 'react';
import { Box, Button, Collapse, Typography, useTheme, Grid, FormControl, InputLabel, NativeSelect, Divider, Select, TextField, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, 
    Paper, IconButton, Slider } from "@mui/material";
import { useParams } from 'react-router-dom';
import Header from '../../../../components/Header';
import WidgetWrapper from '../../../../components/WidgetWrapper';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import MuiInput from '@mui/material/Input';
import useAxiosPrivate from '../../../../hooks/useAxiosPrivate';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Info } from '@mui/icons-material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import {v4} from 'uuid';


const ZoneBuilder = ({
    _id,
    zoneName,
    zoneData,
    allZoneDataLength,
    refresh,
    setRefresh
}) => {
    const [userAddedNameTemp, setUserAddedNameTemp] = useState();
    const [userAddedDescriptionTemp, setUserAddedDescriptionTemp] = useState();
    const [userAddedSegmentationTypeTemp, setUserAddedSegmentationTypeTemp] = useState();
    const [newZoneName, setNewZoneName] = useState(zoneName);
    const [newZoneData, setNewZoneData] = useState(JSON.parse(zoneData));
    const [newZoneDescription, setNewZoneDescription] = useState(newZoneData?.zoneDescription);
    const [newPhysicalNetwork, setNewPhysicalNetwork] = useState(newZoneData?.segmentationType?.physicalNetwork);
    const [newVLAN, setNewVLAN] = useState(newZoneData?.segmentationType?.vlan);
    const [newSDN, setNewSDN] = useState(newZoneData?.segmentationType?.sdn);
    const [newVPN, setNewVPN] = useState(newZoneData?.segmentationType?.vpn);
    const [newSubnetting, setNewSubnetting] = useState(newZoneData?.segmentationType?.subnetting);
    const [newDataDiode, setNewDataDiode] = useState(newZoneData?.boundaryProtection?.dataDiode);
    const [newOther, setNewOther] = useState(newZoneData?.segmentationType?.other);
    const [newFirewall, setNewFirewall] = useState(newZoneData?.boundaryProtection?.firewall);
    const [newRouter, setNewRouter] = useState(newZoneData?.boundaryProtection?.router);
    const [newSwitch, setNewSwitch] = useState(newZoneData?.boundaryProtection?.switch);
    const [newBoundaryOther, setNewBoundaryOther] = useState(newZoneData?.boundaryProtection?.boundaryOther);
    const [newSecurityOperations, setNewSecurityOperations] = useState(newZoneData?.segmentationType?.securityOperations);
    const [newApplicationServer, setNewApplicationServer] = useState(newZoneData?.assetTypes?.applicationServer);
    const [newControlServer, setNewControlServer] = useState(newZoneData?.assetTypes?.controlServer);
    const [newDataGateway, setNewDataGateway] = useState(newZoneData?.assetTypes?.dataGateway);
    const [newDataHistorian, setNewDataHistorian] = useState(newZoneData?.assetTypes?.dataHistorian);
    const [newFieldIO, setNewFieldIO] = useState(newZoneData?.assetTypes?.fieldio);
    const [newHMI, setNewHMI] = useState(newZoneData?.assetTypes?.hmi);
    const [newIED, setNewIED] = useState(newZoneData?.assetTypes?.ied);
    const [newJumpHost, setNewJumpHost] = useState(newZoneData?.assetTypes?.jumpHost);
    const [newPLC, setNewPLC] = useState(newZoneData?.assetTypes?.plc);
    const [newRTU, setNewRTU] = useState(newZoneData?.assetTypes?.rtu);
    const [newRouters, setNewRouters] = useState(newZoneData?.assetTypes?.routers);
    const [newSafetyController, setNewSafetyController] = useState(newZoneData?.assetTypes?.safetyController);
    const [newVPNAsset, setNewVPNAsset] = useState(newZoneData?.assetTypes?.vpnAsset);
    const [newWorkstations, setNewWorkstations] = useState(newZoneData?.assetTypes?.workstations);
    const [newApplicationServerQuantity, setNewApplicationServerQuantity] = useState(newZoneData?.assetTypes?.applicationServerQuantity);
    const [newControlServerQuantity, setNewControlServerQuantity] = useState(newZoneData?.assetTypes?.controlServerQuantity);
    const [newDataGatewayQuantity, setNewDataGatewayQuantity] = useState(newZoneData?.assetTypes?.dataGatewayQuantity);
    const [newDataHistorianQuantity, setNewDataHistorianQuantity] = useState(newZoneData?.assetTypes?.dataHistorianQuantity);
    const [newFieldioQuantity, setNewFieldioQuantity] = useState(newZoneData?.assetTypes?.fieldioQuantity);
    const [newHMIQuantity, setNewHMIQuantity] = useState(newZoneData?.assetTypes?.hmiQuantity);
    const [newIEDQuantity, setNewIEDQuantity] = useState(newZoneData?.assetTypes?.iedQuantity);
    const [newJumpHostQuantity, setNewJumpHostQuantity] = useState(newZoneData?.assetTypes?.jumpHostQuantity);
    const [newPLCQuantity, setNewPLCQuantity] = useState(newZoneData?.assetTypes?.plcQuantity);
    const [newRTUQuantity, setNewRTUQuantity] = useState(newZoneData?.assetTypes?.rtuQuantity);
    const [newRoutersQuantity, setNewRoutersQuantity] = useState(newZoneData?.assetTypes?.routersQuantity);
    const [newSafetyControllerQuantity, setNewSafetyControllerQuantity] = useState(newZoneData?.assetTypes?.safetyControllerQuantity);
    const [newVPNAssetQuantity, setNewVPNAssetQuantity] = useState(newZoneData?.assetTypes?.vpnAssetQuantity);
    const [newWorkstationsQuantity, setNewWorkstationsQuantity] = useState(newZoneData?.assetTypes?.workstationsQuantity);

    const [graphObjectsNodes, setGraphObjectsNodes] = useState([]);
    const [graphObjectsEdges, setGraphObjectsEdges] = useState([]);
    const graphNODES = [];
    

    const Input = styled(MuiInput)` width: 42px;`;

    const { assessmentID } = useParams();

    const axiosPrivate = useAxiosPrivate();
    const newThreatProfileID = 1;
    const threatProfiles = [];
    const theme = useTheme();

    const assetTypeXS = 4;
    const assetTypeQuantityXS = 2

    const HtmlTooltip = styled(({ className, ...props }) => (
            <Tooltip {...props} classes={{ popper: className }} />
          ))(({ theme }) => ({
            [`& .${tooltipClasses.tooltip}`]: {
              backgroundColor: '#f5f5f9',
              color: 'rgba(0, 0, 0, 0.87)',
              maxWidth: 500,
              fontSize: theme.typography.pxToRem(16),
              border: '1px solid #dadde9',
            },
          }));

    const getId = () => {
        let id = v4();
        return (
        `dndnode_${id}`
        )
    }

    const boundaryProtectionNodeWidth = 125;
    const boundaryProgectionNodeHeight = 50;
    const boundaryProtectionNodeColor = 'rgba(151, 38, 7, 0.9)';
    const assetTypeNodeWidth = 150;
    const assetTypeNodeHeight = 50;
    const assetTypeNodeColor = 'rgba(103, 72, 152, 0.9)';
    
    const handleBuildZoneNodes = async () => {
        let tempNodes = [];
        let counterX = 0;
        let counterY = 75;
        let assetCounterX = 0;
        let assetCounterY = 200;
        let totalCount = 0;
        let tempSegTypeLIST = [];

        if (newPhysicalNetwork) {
            tempSegTypeLIST.push("Physical Network ");
        // setTempSegmentationType(tempSegmentationType + "Physical Network ");
        // tempSegType = tempSegType + "Physical Network "
        }
        if (newVPN) {
            tempSegTypeLIST.push("VPN ");
        // setTempSegmentationType(tempSegmentationType + "VPN ");
        // tempSegType = tempSegType + "VPN ";
        }
        if (newVLAN) {
            tempSegTypeLIST.push("VLAN ");
        // tempSegType = tempSegType + "VLAN ";
        }
        if (newSDN) {
            tempSegTypeLIST.push("SDN ");
        // tempSegType = tempSegType + "SDN ";
        }
        if (newSubnetting) {
            tempSegTypeLIST.push("Subnetting ");
        // tempSegType = tempSegType + "Subnetting ";
        };
        if (newOther) {
            tempSegTypeLIST.push("Other ");
        // tempSegType = tempSegType + "Other ";
        };
        tempNodes.push(
            {
                id: getId(), 
                position: {x:(allZoneDataLength*500+((counterX+allZoneDataLength)*20)), y:(0)}, 
                data: {label: newZoneName, description: newZoneDescription, segmentationType: tempSegTypeLIST }, 
                style: {
                backgroundColor: 'rgba(19, 150, 155, 0.2)',
                width: 500, 
                height: 500,
                }, 
                type: 'group' 
            }
        );
        // Boundary Protection Nodes.
        if (newFirewall) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
                data: {label: "Firewall"},
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: boundaryProtectionNodeColor,
                    width:  boundaryProtectionNodeWidth,
                    height: boundaryProgectionNodeHeight,
                }, 
                }
            );
            counterX = counterX + 1;
            };

        if (newRouter) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
                data: {label: "Router"},
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: boundaryProtectionNodeColor,
                    width: boundaryProtectionNodeWidth, 
                    height: boundaryProgectionNodeHeight,
                }, 
                }
            );
            counterX = counterX + 1;
            };

            if (newSwitch) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
                data: {label: "Switch (Layer 3)"},
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: boundaryProtectionNodeColor,
                    width: boundaryProtectionNodeWidth, 
                    height: boundaryProgectionNodeHeight,
                }, 
                }
            );
            counterX = counterX + 1;
            if (counterX > 2) {
                counterX = 0;
                counterY = 135;
            }
            };

            if (newDataDiode) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
                data: {label: "Data Diode"},
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: boundaryProtectionNodeColor,
                    width: boundaryProtectionNodeWidth, 
                    height: boundaryProgectionNodeHeight,
                }, 
                }
            );
            counterX = counterX + 1;
            if (counterX > 2) {
                counterX = 0;
                counterY = 135;
            }
            };

            if (newBoundaryOther) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(counterX*boundaryProtectionNodeWidth+((counterX+1)*15)), y:counterY},
                data: {label: "Other"},
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: boundaryProtectionNodeColor,
                    width: boundaryProtectionNodeWidth, 
                    height: boundaryProgectionNodeHeight,
                }, 
                }
            );
            counterX = counterX + 1;
            };


            // Asset Types
            if (newApplicationServer) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Application Server (${newApplicationServerQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            };
            if (newControlServer) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Control Server (${newControlServerQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            };
            if (newDataGateway) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Data Gateway (${newDataGatewayQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                default:
            }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newDataHistorian) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Data Historian (${newDataHistorianQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
                
            }
            };
            if (newFieldIO) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `FieldIO (${newFieldioQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newHMI) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `HMI (${newHMIQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newIED) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `IED (${newIEDQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newJumpHost) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Jump Host (${newJumpHostQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newPLC) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `PLC (${newPLCQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                case 12:
                    assetCounterY = 400;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newRTU) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `RTU (${newRTUQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                case 12:
                    assetCounterY = 400;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newRouters) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Routers (${newRoutersQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                case 12:
                    assetCounterY = 400;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newSafetyController) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Safety Controller (${newSafetyControllerQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                case 12:
                    assetCounterY = 400;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newVPNAsset) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `VPN (${newVPNAssetQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 300;
                    break;
                case 9:
                    assetCounterY = 350;
                    break;
                case 12:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }
            };
            if (newWorkstations) {
            tempNodes.push(
                {
                id: getId(),
                position: {x:(assetCounterX*assetTypeNodeWidth+((assetCounterX+1)*15)), y:assetCounterY},
                data: {label: `Workstations (${newWorkstationsQuantity})` },
                type: 'default',
                parentId: `grp_${allZoneDataLength}`,
                extent: 'parent',
                style: {
                    backgroundColor: assetTypeNodeColor,
                    width: assetTypeNodeWidth, 
                    height: 40,
                }, 
                }
            );
            assetCounterX = assetCounterX + 1;
            totalCount = totalCount + 1;
            switch (totalCount) {
                case 3:
                    assetCounterY = 250;
                    break;
                case 6:
                    assetCounterY = 250;
                    break;
                case 19:
                    assetCounterY = 300;
                    break;
                case 12:
                    assetCounterY = 350;
                    break;
                default:
                }
            if (assetCounterX > 2) {
                assetCounterX = 0;
            }

        }
        // setGraphObjectsNodes(tempNodes);
        graphNODES.push(tempNodes);
  };


      const handleBlur = async () => {
        await handleBuildZoneNodes();
        let newZoneDataTemp = JSON.stringify({ 'zoneDescription': newZoneDescription, 
            'segmentationType': { 
                "physicalNetwork": newPhysicalNetwork, "vpn": newVPN, "vlan": newVLAN, "sdn": newSDN, "subnetting": newSubnetting, "other": newOther
            },
            'boundaryProtection': {
                "firewall": newFirewall, "router": newRouter, "switch": newSwitch, "dataDiode": newDataDiode, "boundaryOther": newBoundaryOther
            },
            'assetTypes': {
                "applicationServer": newApplicationServer, "applicationServerQuantity": newApplicationServerQuantity,
                "controlServer": newControlServer, "controlServerQuantity": newControlServerQuantity,
                "dataGateway": newDataGateway, "dataGatewayQuantity": newDataGatewayQuantity,
                "dataHistorian": newDataHistorian, "dataHistorianQuantity": newDataHistorianQuantity,
                "fieldio": newFieldIO, "fieldioQuantity": newFieldioQuantity,
                "hmi": newHMI, "hmiQuantity": newHMIQuantity,
                "ied": newIED, "iedQuantity": newIEDQuantity,
                "jumpHost": newJumpHost, "jumpHostQuantity": newJumpHostQuantity,
                "plc": newPLC, "plcQuantity": newPLCQuantity,
                "rtu": newRTU,"rtuQuantity": newRTUQuantity,
                "routers": newRouters, "routersQuantity": newRoutersQuantity,
                "safetyController": newSafetyController, "safetyControllerQuantity": newSafetyControllerQuantity,
                "vpnAsset": newVPNAsset, "vpnAssetQuantity": newVPNAssetQuantity,
                "workstations": newWorkstations, "workstationsQuantity": newWorkstationsQuantity
            }
            });
            let nodes = graphNODES;
            let edges = graphObjectsEdges;
            console.log(nodes);
            let graphObjects = { nodes, edges};
          try {
              const responsePatch = await axiosPrivate.patch(`/zones/${_id}`,
                  JSON.stringify({ 'zoneName': newZoneName, 'zoneDescription': newZoneDescription, 'zoneData': newZoneDataTemp, 'graphObjects': graphObjects  }),
                  {
                      headers: { 'Content-Type': 'application/json' },
                      withCredentials: true
                  }
                  );
                  const data = await responsePatch.data;
                  setRefresh(!refresh);
                  // Axios provides responses in JSON by default. The response JSON is always named 'data'. 
                  // The console log commands below allow you to see the responses from Axios for the response.  
                  // navigate(from, { replace: true });
              } catch (err) {
              //   alert("Login Expired.Conswquence Threshold");
                  console.error(err);
              //   navigate('/login', { state: { from: location }, replace: true });
              }
            // setRefresh(!refresh);
      };
     

    //   const onChangeComments = async (e) => {
    //     setNewThreatProfileComments(e);
    //     let threatProfileComments = e;
    //         try {
    //             const responsePatch = await axiosPrivate.patch(`/threatprofiles/threatprofiles/${_id}`,
    //                 JSON.stringify({ threatProfileComments }),
    //                 {
    //                     headers: { 'Content-Type': 'application/json' },
    //                     withCredentials: true
    //                 }
    //                 );
    //                 const data = await responsePatch.data;
    //                 // Axios provides responses in JSON by default. The response JSON is always named 'data'. 
    //                 // The console log commands below allow you to see the responses from Axios for the response.  
    //                 // navigate(from, { replace: true });
    //             } catch (err) {
    //             //   alert("Login Expired.Conswquence Threshold");
    //                 console.error(err);
    //             //   navigate('/login', { state: { from: location }, replace: true });
    //             }

    //    };


       const handleDeleteZone = async (_id) => {
        try {
            const response = await axiosPrivate.delete(`/zones/${_id}`, 
              {
                  headers: { 'Content-Type': 'application/json' },
                  withCredentials: true
              }
          );
            if (response.data.success) {
                alert(response.data.msg);
            } 
        } catch (err) {
            console.error(err);
        }
        setRefresh(!refresh);
     };

     const assetTypesList = [
        {
            value: 'applicationServer',
            label: 'Application Server',
            description: 'Application servers are used across many different sectors to host various diverse software applications necessary to supporting the ICS. Example functions can include data analytics and reporting, alarm management, and the management/coordination of different control servers. The application server typically runs on a modern server operating system (e.g., MS Windows Server).',
            example: 'Windows Server 2022, Red Hat Enterprise Linux 9, or other Linux server'
        },
        {
            value: 'controlServer',
            label:'Control Server',
            description: 'Control servers are typically a software platform that runs on a modern server operating system (e.g., MS Windows Server). The server typically uses one or more automation protocols (e.g., Modbus, DNP3) to communicate with the various low-level control devices such as Remote Terminal Units (RTUs) and Programmable Logic Controllers (PLCs). The control server also usually provides an interface/network service to connect with an HMI.',
            example: 'SCADA Server, MTU, Distributed/Energy Management System'
        },
        {
            value: 'dataGateway',
            label: 'Data Gateway',
            description: 'Data Gateway is a device that supports the communication and exchange of data between different systems, networks, or protocols within the ICS. Different types of data gateways are used to perform various functions, including: Protocol Translators, Media Converters, and Data Aggregators. Data gateways are often critical to the forwarding/transmission of critical control or monitoring data within the ICS. Further, these devices often have remote various network services that are used to communicate across different zones or networks.',
            example: 'Data Acquisition Server, Serial to Ethernet Gateway'
        },
        {
            value: 'dataHistorian',
            label: 'Data Historian',
            description: 'Data historians, or historian, are systems used to collect and store data, including telemetry, events, alerts, and alarms about the operational process and supporting devices. The historian typically utilizes a database to store this data, and commonly provide tools and interfaces to support the analysis of the data. Data historians are often used to support various engineering or business analysis functions and therefore commonly needs access from the corporate network.',
            example: 'GE Proficy, Ignition Historian'
        },
        {
            value: 'fieldIO',
            label: 'Field I/O',
            description: 'Field I/O are devices that communicate with a controller or data aggregator to either send input data or receive output data. Input data may include readings about a given environment/device state from sensors, while output data may include data sent back to actuators for them to either undertake actions or change parameter values. These devices are frequently embedded devices running on lightweight embedded operating systems or RTOSes.',
            example: 'Smart Sensors, Variable Frequency Drives'
        },
        {
            value: 'humanMachineInterface', 
            label: 'Human Machine Interface',
            description: 'Human-Machine Interfaces (HMIs) are systems used by an operator to monitor the real-time status of an operational process and to perform necessary control functions, including the adjustment of device parameters. An HMI can take various forms, including a dedicated screen or control panel integrated with a specific device/controller, or a customizable software GUI application.',
            example: 'Operator Workstations, Consoles, or Mounted Touchscreens'
        },
        {
            value: 'intelligentElectronicDevice', 
            label: 'Intelligent Electronic Device',
            description: 'An Intelligent Electronic Device (IED) is a type of specialized field device that is designed to perform specific operational functions, frequently for protection, monitoring, or control within the electric sector. IEDs are typically used to both acquire telemetry and execute tailored control algorithms/actions based on customizable parameters/settings. An IED is usually implemented as a dedicated embedded device and supports various network automation protocols to communicate with RTUs and Control Servers.',
            example: 'Protection Relay, Field Device Controller'
        },
        {
            value: 'jumpHost',
            label: 'Jump Host',
            description: 'Jump hosts are devices used to support remote management sessions into ICS networks or devices. The system is used to access the ICS environment securely from external networks, such as the corporate network. The user must first remote into the jump host before they can access ICS devices. The jump host may be a customized Windows server using common remote access protocols (e.g., RDP) or a dedicated access management device. The jump host typically performs various security functions to ensure the authenticity of remote sessions, including authentication, enforcing access controls/permissions, and auditing all access attempts.',
            example: 'Intermediate System, Bastion Host, or Gateway'
        },
        {
            value: 'programmableLogicController',
            label: 'Programmable Logic Controller',
            description: 'A Programmable Logic Controller (PLC) is an embedded programmable control device. PLCs typically utilize a modular architecture with separate modules used to support its processing capabilities, communication mediums, and I/O interfaces. PLCs allow for the deployment of customized programs/logic to control or monitor an operational process.',
            example:'Process Automation Controller, Field Device Controller'
        }, 
        {
            value: 'remoteTerminalUnit', 
            label: 'Remote Terminal Unit',
            description: 'A Remote Terminal Unit (RTU) is a device that typically resides between field devices (e.g., PLCs, IEDs) and control/SCADA servers and supports various communication interfacing and data aggregation functions. RTUs are typically responsible for forwarding commands from the control server and the collection of telemetry, events, and alerts from the field devices.',
            example: 'Motorola ACE'
        },
        {
            value: 'router',
            label: 'Router',
            description: 'A computer that is a gateway between two networks at OSI layer 3 and that relays and directs data packets through that inter-network. The most common form of router operates on IP packets.',
            example: 'Cisco, Ubiquiti, TP-Link, NetGear'
        },
        {
            value: 'safetyController',
            label: 'Safety Controller',
            description: 'Safety controllers are typically a type of field device used to perform the safety critical function. Safety controllers often support the deployment of custom programs/logic, similar to a PLC, but can also be tailored for sector specific functions/applications.',
            example: 'Safety Instrumented System (SIS) Contoller, Emergency Shutdown Systems (EMS) Controller, Burner Management Systesm (BMS) Controller'
        },
        {
            value: 'virtualPrivateNetworkServer', 
            label: 'VPN Server',
            description: 'A VPN server is a device that is used to establish a secure network tunnel between itself and other remote VPN devices, including field VPNs. VPN servers can be used to establish a secure connection with a single remote device, or to securely bridge all traffic between two separate networks together by encapsulating all data between those networks.',
            example: 'Virtual Private Network (VPN) Terminator, Field VPN, Cisco AnyConnect, Ivanti'
        },
        {
            value: 'workstation', 
            label: 'Workstation',
            description: 'Workstations are devices used by human operators or engineers to perform various configuration, programming, maintenance, diagnostic, or operational tasks. Workstations typically utilize standard desktop or laptop hardware and operating systems (e.g., MS Windows), but run dedicated control system applications or diagnostic/management software to support interfacing with the control servers or field devices.',
            example: 'Transient Cyber Asset (TCA), Engineering Workstation (EWS), Windows 11 Laptop or Desktop, Linux Laptop or Desktop'
        },
        {
            value: 'physicalNetwork', 
            label: 'Physical Network',
            description: 'In this context, a physical netowrk is one where all the devices share the same hardware and has no logical isolation. This is often referred to as a "flat" network.',
            example: ''
        },
        {
            value: 'vlan', 
            label: 'Virtual Local Area Network',
            description: 'A VLAN can be used to logically separate areas within a network when physical separation may not be feasible. VLANs are implemented on modern network switching equipment that logically separates network traffic based on switch ports. For example, an 8-port switch can be configured to separate traffic into two VLANs. One VLAN would be provided for ports 1-4, while another would be provided for ports 5-8. While all eight ports are physically connected to a single device, each port is only logically connected to the other ports within its VLAN.',
            example: ''
        },
        {
            value: 'sdn', 
            label: 'Software Defined Network',
            description: 'SDN is a technology that separates the network data plane (forwarding packets) and control plane (packet routing). The data plane stays at the switch, and the control plane is moved to a centralized controller. The centralized controller acts as an abstraction layer for network programmability, eliminating the need to individually manage each switch within the network. SDN allows for easy dynamic reconfiguration of the data plane, which can in turn allow for the quick isolation of devices or redirection and duplication of traffic for monitoring and data capture. SDN technology gives OT asset owners greater flexibility when designing and updating their network architecture.',
            example: ''
        },
        {
            value: 'subnetting', 
            label: 'Subnetting',
            description: 'Subnetting is the process of dividing a large network into smaller networks called "subnets." Subnets provide each group of devices with their own space to communicate, which ultimately helps the network to work easily. This also boosts security and makes it easier to manage the network, as each subnet can be monitored and controlled separately.',
            example: ''
        },
        {
            value: 'firewall', 
            label: 'Firewall',
            description: 'A firewall is a device that manages network traffic to safeguard the network from intentional or unintentional intrusion. A firewall sits at the junction point between the two networks, usually a private network and a public network such as the Internet. By segmenting a network into different physical subnetworks, firewalls limit damage that could spread from one subnet to another.',
            example: ''
        },
        {
            value: 'switchLayer3', 
            label: 'Switch (Layer 3)',
            description: 'A Layer-3 switch works at the third layer of the OSI mode and it has features of both a switch and a router. Where a Layer 2 or traditional swtich routes traffic based on MAC address, a Layer 3 swtich uses IP addresses to forward packets and route among one or different networks, subnets, or VLANs.',
            example: ''
        },
        {
            value: 'dataDiode', 
            label: 'Data Diode',
            description: 'A network appliance or device that allows data to travel only in one direction. Also referred to as a unidirectional gateway, deterministic one-way boundary device, or unidirectional network. Rather than using logic to control traffic like a firewall, a diode uses the physical characteristics of the specific materials that have very little electrical resistance in one direction and infinite resistance in the other direction.',
            example: ''
        },
    ];


    return (
    <Box sx={{ width:'100%', border:'solid 3px', mt:'1rem', p:'1rem', backgroundColor: '#E0E0E0' }}>
    
            <Grid container spacing={2} sx={{ display:'flex', p:'1rem', justifyContent:'space-evenly' }}>
                <Grid item xs={12}>
                <Box sx={{ display:'flex', justifyContent:'center', alignItems:'center' }}>
                    <Button sx={{ ml:'3px', color:'black' }} onClick={() => {handleDeleteZone(_id)}}><DeleteForeverIcon sx={{ fontSize:'28pt' }} /></Button>
                </Box>
                </Grid>

                 {/*  NAME  */}
                <Grid item xs={12}>
                    <Typography>Name:</Typography>
                    <input style={{ height: '60px', width: '100%' }}
                        type="text"
                        id="zoneName"
                        value={newZoneName || ""}
                        onChange={(e) => setNewZoneName(e.target.value)}
                        onBlur={handleBlur}
                    />
                </Grid>

                 {/*  DESCRIPTION   */}
                <Grid item xs={12}>
                    <Typography>Description:</Typography>
                    <textarea name="text" wrap="soft" rows="5" cols="15" autoComplete='off' maxLength={100} style={{ display: 'grid', resize:'none', overflow: 'auto', textAlign: 'left', width: '100%' }} onChange={(e) => setNewZoneDescription(e.target.value)} onBlur={handleBlur} >{newZoneData?.zoneDescription}</textarea>
                </Grid>

                 {/*  SEGMENTATION TYPE  */}
                <Grid item xs={12}>
                    <Typography>Segmentation Type:</Typography>
                    <Box sx={{ width:'100%', border:'solid 1px', p:'1rem', backgroundColor: '#E0E0E0' }}>
                    <Grid container spacing={2} >
                        <Grid item xs={4}>
                            <input
                                name='physicalNetwork'
                                type="checkbox"
                                id='physicalNetwork'
                                value={true}
                                checked={newPhysicalNetwork}
                                onChange={(e) => setNewPhysicalNetwork(!newPhysicalNetwork)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[14].description} 
                                </React.Fragment>} 
                                >
                                    <label htmlFor="physicalNetwork">Physical Network</label>
                            </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='vlan'
                                type="checkbox"
                                id='vlan'
                                value={true}
                                checked={newVLAN}
                                onChange={(e) => setNewVLAN(!newVLAN)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[15].description} 
                                </React.Fragment>} 
                                >
                                    <label htmlFor="vlan">Virtual Local Area Network</label>
                                </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='sdn'
                                type="checkbox"
                                id='sdn'
                                value={true}
                                checked={newSDN}
                                onChange={(e) => setNewSDN(!newSDN)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[16].description} 
                                </React.Fragment>} 
                                >
                                    <label htmlFor="sdn">Software Defined Network</label>
                                </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='vpn'
                                type="checkbox"
                                id='vpn'
                                value={true}
                                checked={newVPN}
                                onChange={(e) => setNewVPN(!newVPN)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[12].description} <br /><br />Examples include: {assetTypesList[12].example}
                                </React.Fragment>} 
                                >
                                    <label htmlFor="vpn">Virtual Private Network</label>
                                </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='subnetting'
                                type="checkbox"
                                id='subnetting'
                                value={true}
                                checked={newSubnetting}
                                onChange={(e) => setNewSubnetting(!newSubnetting)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[17].description}
                                </React.Fragment>} 
                                >
                                    <label htmlFor="subnetting">Subnetting</label>
                                </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='other'
                                type="checkbox"
                                id='other'
                                value={true}
                                checked={newOther}
                                onChange={(e) => setNewOther(!newOther)}
                                onBlur={handleBlur}
                            />
                            <label htmlFor="other">Other</label>
                        </Grid>
                    </Grid>
                    </Box>
                </Grid>

                {/*  BOUNDARY PROTECTION  */}
                <Grid item xs={12}>
                    <Typography>Boundary Protection:</Typography>
                    <Box sx={{ width:'100%', border:'solid 1px', p:'1rem', backgroundColor: '#E0E0E0' }}>
                    <Grid container spacing={2} >
                        <Grid item xs={4}>
                            <input
                                name='firewall'
                                type="checkbox"
                                id='firewall'
                                value={true}
                                checked={newFirewall}
                                onChange={(e) => setNewFirewall(!newFirewall)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[18].description} 
                                </React.Fragment>} 
                                >
                                    <label htmlFor="firewall">Firewall</label>
                            </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='router'
                                type="checkbox"
                                id='router'
                                value={true}
                                checked={newRouter}
                                onChange={(e) => setNewRouter(!newRouter)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[10].description} <br /><br />Examples include: {assetTypesList[10].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="router">Router</label>
                                </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='switch'
                                type="checkbox"
                                id='switch'
                                value={true}
                                checked={newSwitch}
                                onChange={(e) => setNewSwitch(!newSwitch)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[19].description} 
                                </React.Fragment>} 
                                >
                                    <label htmlFor="switch">Switch (Layer 3)</label>
                            </HtmlTooltip>
                            
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='dataDiode'
                                type="checkbox"
                                id='dataDiode'
                                value={true}
                                checked={newDataDiode}
                                onChange={(e) => setNewDataDiode(!newDataDiode)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                <React.Fragment>
                                    {assetTypesList[20].description} 
                                </React.Fragment>} 
                                >
                                    <label htmlFor="dataDiode">Data Diode</label>
                            </HtmlTooltip>
                        </Grid>
                        <Grid item xs={4}>
                            <input
                                name='boundaryOther'
                                type="checkbox"
                                id='boundaryOther'
                                value={true}
                                checked={newBoundaryOther}
                                onChange={(e) => setNewBoundaryOther(!newBoundaryOther)}
                                onBlur={handleBlur}
                            />
                            <label htmlFor="boundaryOther">Other</label>
                        </Grid>
                    </Grid>
                    </Box>
                </Grid>

                 {/*  SECURITY OPERATIONS   */}
                {/* <Grid item xs={12}>
                    <Box>
                        <FormControl fullWidth>
                            <Typography>Security Operations</Typography>
                            <Select value={newSecurityOperations} sx={{ height:'5vh', width:'90%', display:'flex', justifyContent:'center', alignItems:'center' }} onChange={(e) => setNewSecurityOperations(e.target.value) }>
                                <MenuItem value="Actively Monitored">Actively Monitored</MenuItem>
                                <MenuItem value="Logs collected and reviewed">Logs collected and reviewed</MenuItem>
                                <MenuItem value="Logs collected but not reviewed">Logs collected but not reviewed</MenuItem>
                                <MenuItem value="Logs not collected">Logs not collected</MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                </Grid> */}

                 {/*  ASSET TYPES  */}
                <Grid item xs={12}>
                    <Typography>Asset Types:</Typography>
                    <Box sx={{ width:'100%', border:'solid 1px', p:'1rem', backgroundColor: '#E0E0E0' }}>
                    <Grid container spacing={2} >
                        <Grid item xs={assetTypeXS} sx={{ mb:'1rem'}}>  
                            <input
                                name='applicationServer'
                                type="checkbox"
                                id='applicationServer'
                                value={true}
                                checked={newApplicationServer}
                                onChange={(e) => setNewApplicationServer(!newApplicationServer)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[0].description} <br /><br />Examples include: {assetTypesList[0].example}
                                    </React.Fragment>} 
                                    >
                                    <label htmlFor="applicationServer">Application Server</label>
                            </HtmlTooltip>
                        {/* </Grid> */}
                        {/* <Grid item xs={assetTypeQuantityXS} > */}
                        <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="applicationServerQuantity">Number of devices: </label>
                            <input 
                                disabled={!newApplicationServer}
                                min={0}
                                max={50000}
                                type="number"
                                id="applicationServerQuantity"
                                name="applicationServerQuantity"
                                value={!newApplicationServer ? (0) : (newApplicationServerQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewApplicationServerQuantity(50000)) : (setNewApplicationServerQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newApplicationServer ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS} sx={{ mb:'1rem'}}>
                            <input
                                name='controlServer'
                                type="checkbox"
                                id='controlServer'
                                value={true}
                                checked={newControlServer}
                                onChange={(e) => setNewControlServer(!newControlServer)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[1].description} <br /><br />Examples include: {assetTypesList[1].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="controlServer">Control Server</label>
                                </HtmlTooltip>
                        {/* </Grid>
                        <Grid item xs={assetTypeQuantityXS}> */}
                        <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="controlServerQuantity">Number of devices:</label>
                            <input 
                                disabled={!newControlServer}
                                min={0}
                                type="number"
                                id="controlServerQuantity"
                                name="controlServerQuantity"
                                value={!newControlServer ? (0) : (newControlServerQuantity)}
                                onChange={(e) => setNewControlServerQuantity(e.target.value)}
                                onBlur={handleBlur}
                                style={ newControlServer ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                    { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS} sx={{ mb:'1rem'}}>
                            <input
                                name='dataGateway'
                                type="checkbox"
                                id='dataGateway'
                                value={true}
                                checked={newDataGateway}
                                onChange={(e) => setNewDataGateway(!newDataGateway)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[2].description} <br /><br />Examples include: {assetTypesList[2].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="dataGateway">Data Gateway</label>
                                </HtmlTooltip>
                                <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="dataGatewayQuantity">Number of devices: </label>
                            <input 
                                disabled={!newDataGateway}
                                min={0}
                                max={50000}
                                type="number"
                                id="dataGatewayQuantity"
                                name="dataGatewayQuantity"
                                value={!newDataGateway ? (0) : (newDataGatewayQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewDataGatewayQuantity(50000)) : (setNewDataGatewayQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newDataGateway ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS} sx={{ mb:'1rem'}}>
                            <input
                                name='dataHistorian'
                                type="checkbox"
                                id='dataHistorian'
                                value={true}
                                checked={newDataHistorian}
                                onChange={(e) => setNewDataHistorian(!newDataHistorian)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[3].description} <br /><br />Examples include: {assetTypesList[3].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="dataHistorian">Data Historian</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="dataHistorianQuantity">Number of devices: </label>
                            <input 
                                disabled={!newDataHistorian}
                                min={0}
                                max={50000}
                                type="number"
                                id="newDataHistorianQuantity"
                                name="newDataHistorianQuantity"
                                value={!newDataHistorian ? (0) : (newDataHistorianQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewDataHistorianQuantity(50000)) : (setNewDataHistorianQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newDataHistorian ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='fieldio'
                                type="checkbox"
                                id='fieldio'
                                value={true}
                                checked={newFieldIO}
                                onChange={(e) => setNewFieldIO(!newFieldIO)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[4].description} <br /><br />Examples include: {assetTypesList[4].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="fieldio">Field I/O</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="fieldioQuantity">Number of devices: </label>
                            <input 
                                disabled={!newFieldIO}
                                min={0}
                                max={50000}
                                type="number"
                                id="fieldioQuantity"
                                name="fieldioQuantity"
                                value={!newFieldIO ? (0) : (newFieldioQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewFieldioQuantity(50000)) : (setNewFieldioQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newFieldIO ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                    { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='hmi'
                                type="checkbox"
                                id='hmi'
                                value={true}
                                checked={newHMI}
                                onChange={(e) => setNewHMI(!newHMI)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[5].description} <br /><br />Examples include: {assetTypesList[5].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="hmi">Human Machine Interface (HMI)</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="hmiQuantity">Number of devices: </label>
                            <input 
                                disabled={!newHMI}
                                min={0}
                                max={50000}
                                type="number"
                                id="hmiQuantity"
                                name="hmiQuantity"
                                value={!newHMI ? (0) : (newHMIQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewHMIQuantity(50000)) : (setNewHMIQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newHMI ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='ied'
                                type="checkbox"
                                id='ied'
                                value={true}
                                checked={newIED}
                                onChange={(e) => setNewIED(!newIED)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[6].description} <br /><br />Examples include: {assetTypesList[6].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="ied">Intelligent Electronic Device (IED)</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="iedQuantity">Number of devices: </label>
                            <input 
                                disabled={!newIED}
                                min={0}
                                max={50000}
                                type="number"
                                id="iedQuantity"
                                name="iedQuantity"
                                value={!newIED ? (0) : (newIEDQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewIEDQuantity(50000)) : (setNewIEDQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newIED ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='jumphost'
                                type="checkbox"
                                id='jumphost'
                                value={true}
                                checked={newJumpHost}
                                onChange={(e) => setNewJumpHost(!newJumpHost)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[7].description} <br /><br />Examples include: {assetTypesList[7].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="jumphost">Jump Host</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newJumpHostQuantity">Number of devices: </label>
                            <input 
                                disabled={!newJumpHost}
                                min={0}
                                max={50000}
                                type="number"
                                id="newJumpHostQuantity"
                                name="newJumpHostQuantity"
                                value={!newJumpHost ? (0) : (newJumpHostQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewJumpHostQuantity(50000)) : (setNewJumpHostQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newJumpHost ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='plc'
                                type="checkbox"
                                id='plc'
                                value={true}
                                checked={newPLC}
                                onChange={(e) => setNewPLC(!newPLC)}
                                onBlur={handleBlur}
                            />  
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[8].description} <br /><br />Examples include: {assetTypesList[8].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="plc">Programmable Logic Controller (PLC)</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newPLCQuantity">Number of devices: </label>
                            <input 
                                disabled={!newPLC}
                                min={0}
                                max={50000}
                                type="number"
                                id="newPLCQuantity"
                                name="newPLCQuantity"
                                value={!newPLC ? (0) : (newPLCQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewPLCQuantity(50000)) : (setNewPLCQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newPLC ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='rtu'
                                type="checkbox"
                                id='rtu'
                                value={true}
                                checked={newRTU}
                                onChange={(e) => setNewRTU(!newRTU)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[9].description} <br /><br />Examples include: {assetTypesList[9].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="rtu">Remote Terminal Unit (RTU)</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newRTUQuantity">Number of devices: </label>
                            <input 
                                disabled={!newRTU}
                                min={0}
                                max={50000}
                                type="number"
                                id="newRTUQuantity"
                                name="newRTUQuantity"
                                value={!newRTU ? (0) : (newRTUQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewRTUQuantity(50000)) : (setNewRTUQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newRTU ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='routers'
                                type="checkbox"
                                id='routers'
                                value={true}
                                checked={newRouters}
                                onChange={(e) => setNewRouters(!newRouters)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[10].description} <br /><br />Examples include: {assetTypesList[10].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="routers">Routers</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newRoutersQuantity">Number of devices: </label>
                            <input 
                                disabled={!newRouters}
                                min={0}
                                max={50000}
                                type="number"
                                id="newRoutersQuantity"
                                name="newRoutersQuantity"
                                value={!newRouters ? (0) : (newRoutersQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewRoutersQuantity(50000)) : (setNewRoutersQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newRouters ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='safetyController'
                                type="checkbox"
                                id='safetyController'
                                value={true}
                                checked={newSafetyController}
                                onChange={(e) => setNewSafetyController(!newSafetyController)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[11].description} <br /><br />Examples include: {assetTypesList[11].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="safetyController">Safety Controller</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newSafetyControllerQuantity">Number of devices: </label>
                            <input 
                                disabled={!newSafetyController}
                                min={0}
                                max={50000}
                                type="number"
                                id="newSafetyControllerQuantity"
                                name="newSafetyControllerQuantity"
                                value={!newSafetyController ? (0) : (newSafetyControllerQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewSafetyControllerQuantity(50000)) : (setNewSafetyControllerQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newSafetyController ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='vpnAsset'
                                type="checkbox"
                                id='vpnAsset'
                                value={true}
                                checked={newVPNAsset}
                                onChange={(e) => setNewVPNAsset(!newVPNAsset)}
                                onBlur={handleBlur}
                            />
                            <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[12].description} <br /><br />Examples include: {assetTypesList[12].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="vpnAsset">Virtual Private Network (VPN)</label>
                                </HtmlTooltip>
                                  <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newVPNAssetQuantity">Number of devices: </label>
                            <input 
                                disabled={!newVPNAsset}
                                min={0}
                                max={50000}
                                type="number"
                                id="newVPNAssetQuantity"
                                name="newVPNAssetQuantity"
                                value={!newVPNAsset ? (0) : (newVPNAssetQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewVPNAssetQuantity(50000)) : (setNewVPNAssetQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newVPNAsset ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                        <Grid item xs={assetTypeXS}>
                            <input
                                name='workstations'
                                type="checkbox"
                                id='workstations'
                                value={true}
                                checked={newWorkstations}
                                onChange={(e) => setNewWorkstations(!newWorkstations)}
                                onBlur={handleBlur}
                            />
                                 <HtmlTooltip placement="right-start" title={
                                    <React.Fragment>
                                       {assetTypesList[13].description} <br /><br />Examples include: {assetTypesList[13].example}
                                    </React.Fragment>} 
                                    >
                                        <label htmlFor="workstations">Workstations</label>
                                </HtmlTooltip>
                                 <br />
                            <label style={{ marginLeft:'1rem', fontSize:'12pt' }} htmlFor="newWorkstationsQuantity">Number of devices: </label>
                            <input 
                                disabled={!newWorkstations}
                                min={0}
                                max={50000}
                                type="number"
                                id="newWorkstationsQuantity"
                                name="newWorkstationsQuantity"
                                value={!newWorkstations ? (0) : (newWorkstationsQuantity)}
                                onChange={(e) => {e.target.value > 50001 ? (setNewWorkstationsQuantity(50000)) : (setNewWorkstationsQuantity(e.target.value))}}
                                onBlur={handleBlur}
                                style={ newWorkstations ? (
                                    { backgroundColor:"white", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                    ) : (
                                        { backgroundColor:"grey", width: '40%', fontSize: '14pt', fontFamily: ["Rubik", "sans-serif"] }
                                )}
                            />
                        </Grid>
                    </Grid>
                    </Box>
                </Grid>
            </Grid>
        
        </Box>
  )
}

export default ZoneBuilder 